import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {NotificationDialog, NotificationDialogDefinition} from '@aviary/dialogs/notification-dialog/notification-dialog.types';
import {NotificationDialogComponent} from '@aviary/dialogs/notification-dialog/notification-dialog.component';

export interface EmailChangeSubmittedDialogData {
  email: string;
}

@Component({
  selector: 'px-email-change-submitted',
  template: `
    <mx-notification-dialog [definition]="dialogDefinition">
      <!-- Add separate text above the prompt since the design calls for varying typography. -->
      <div class="flex flex-col">
        <p class="text-title-large">You’re almost there! We sent an email to:</p>
        <p class="text-body-large break-all">{{ dialogData.email }}</p>
      </div>
    </mx-notification-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NotificationDialogComponent]
})
export class EmailChangeSubmittedDialog implements NotificationDialog<EmailChangeSubmittedDialogData> {

  public readonly dialogData: EmailChangeSubmittedDialogData = inject(MAT_DIALOG_DATA);

  public readonly dialogDefinition: NotificationDialogDefinition = {
    title: 'New Email Submitted',
    prompt: 'Click the link in that email to verify your email address and complete the change. If you don’t see it, you may need to check your spam folder.',
    confirmButtonLabel: 'Close'
  };
}
